import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent  implements AfterViewInit {
  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService,  private cdr: ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();
  }

  ngAfterViewInit(): void {
    const setting = 
      { post: {url: '/admin/notification/get', data: {page_nat: true}},
        disabled_pagenat: false,
        fields: [
          {label: 'No', type: 'index'}, 
          {label: 'Title', type: 'string', key: 'title'}, 
          {label: 'Description', type: 'html', key: 'descp'},
          {label: 'Mark as Read', type: 'button', key: 'is_read', action: async (data:any) => {
            if(data.status == 1) {
              return;
            }
            data.status = 1;
            await this.http.post('/admin/notification/mark-as-read', data);
          }},
          {label: 'DateTime', type: 'datetime', key: 'create_on'}
        ],
        row: {
          class: (data:any) => {
            if(data.status == 2) {
              return 'bg-warning text-dark';
            }
            return "text-dark"
          }
        }
      }
    this.tb.init(setting);
    this.cdr.detectChanges();
  }

}